import React from 'react'
import {
  Box as LeftColumn,
  Box as OuterContainer,
  Box as RightColumn,
  Box as Wrapper,
} from '@node-space/ui-components'

export interface PageHeaderProps {
  description?: React.ReactNode | string
  renderRightSection?: React.ReactNode
}

export const PageHeader = ({ description, renderRightSection }: PageHeaderProps) => {
  return (
    <OuterContainer className="mb-9">
      <Wrapper className="min-h-10 items-center sm:flex sm:space-x-28">
        <LeftColumn className="flex-auto">
          {description && (
            <>
              {typeof description === 'string' ? (
                <p className="text-foreground-subdued text-body-regular">{`${description}`}</p>
              ) : (
                description
              )}
            </>
          )}
        </LeftColumn>

        {renderRightSection && (
          <RightColumn className="mt-4 sm:mt-0">{renderRightSection}</RightColumn>
        )}
      </Wrapper>
    </OuterContainer>
  )
}
